import { useEffect } from 'react';

/** Re-expands a collapsible whenever `token` changes to a defined value (gating errors, §2.2). */
export default function useForceExpand(token: number | undefined, setExpanded: (expanded: boolean) => void): void {
    useEffect(() => {
        if (token !== undefined) {
            setExpanded(true);
        }
    }, [token, setExpanded]);
}
